import { motion } from "framer-motion";
import { Zap, MonitorSmartphone } from "lucide-react";
import { LogoMark } from "@/components/Logo";

const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "393330000000";
const WA_MSG = encodeURIComponent("Ciao Tecnico Auto & Truck, vorrei informazioni per una diagnosi sul mio veicolo.");

export const WhatsAppFloat = () => (
  <a
    data-testid="whatsapp-floating-btn"
    href={`https://wa.me/${WA_NUMBER}?text=${WA_MSG}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Assistenza rapida WhatsApp"
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-obsidian flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-200"
  >
    <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
      <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.19 8.19 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01" />
    </svg>
  </a>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/5 bg-[#0E1017]">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-3">
          <LogoMark size={30} />
          <span className="font-display font-extrabold tracking-tight text-base text-white">
            TECNICO AUTO <span className="text-volt">&amp;</span> TRUCK
          </span>
        </div>
        <p className="mt-4 text-sm text-slate-500 leading-relaxed max-w-xs">
          Consulenza meccanica ed elettrauto per auto e camion. In officina e da remoto,
          con diagnosi video e sessioni TeamViewer.
        </p>
      </div>
      <div>
        <p className="eyebrow mb-5">Contatti</p>
        <ul className="space-y-3 text-sm text-slate-400">
          <li>
            <a data-testid="footer-email-link" href="mailto:zaccajj81@gmail.com" className="hover:text-volt transition-colors">
              zaccajj81@gmail.com
            </a>
          </li>
          <li>
            <a data-testid="footer-phone-link" href="tel:+393485794417" className="hover:text-volt transition-colors">
              +39 348 579 4417
            </a>
          </li>
          <li>
            <a data-testid="footer-whatsapp-link" href={`https://wa.me/${WA_NUMBER}`} target="_blank" rel="noopener noreferrer" className="hover:text-volt transition-colors">
              WhatsApp diretto
            </a>
          </li>
          <li className="flex items-center gap-2 text-slate-500">
            <MonitorSmartphone size={14} className="text-volt" /> Sessioni remote via TeamViewer
          </li>
        </ul>
      </div>
      <div>
        <p className="eyebrow mb-5">Orari Consulenze</p>
        <ul className="space-y-2 font-mono text-xs text-slate-500 uppercase tracking-wider">
          <li>Lun — Sab · 09:00 – 12:00</li>
          <li>Lun — Sab · 14:00 – 18:00</li>
          <li className="text-spark">Domenica · Chiuso</li>
        </ul>
        <a
          data-testid="footer-admin-link"
          href="/admin"
          className="mt-6 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600 hover:text-volt transition-colors"
        >
          <Zap size={11} /> Area Riservata
        </a>
      </div>
    </div>
    <div className="border-t border-white/5 py-5 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
      © {new Date().getFullYear()} Tecnico Auto &amp; Truck — Tutti i diritti riservati
    </div>
  </footer>
);
